import React from "react";

import { postData } from "../hooks/useFirebase";
import "./HighScoreModal.css";

const mainClass = "HighScoreModal";

const HighScore = ({ gameStats, setHighScore }: any) => {
  const [playerName, setPlayerName] = React.useState(null);
  const [tempName, setTempName] = React.useState(null);

  const { points } = gameStats;

  const handleInputchange = (e: any) => {
    setTempName(e.target.value);
  };

  const handleSumbit = (e: any) => {
    e.preventDefault();
    if (tempName && tempName !== "") {
      setPlayerName(tempName);
      e.target.reset();
      setHighScore(0);

      postData({ name: tempName, points });
    }
  };
  return (
    <div className={mainClass}>
      <form onSubmit={handleSumbit}>
        <div className={`${mainClass}--message`}>
          High score!!!! <br />
          Enter your name
        </div>
        <input
          className={`${mainClass}--input`}
          autoFocus
          onChange={handleInputchange}
          maxLength={10}
        />
      </form>
    </div>
  );
};

export default HighScore;
